import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import VideoSection from './components/VideoSection';
import SlideViewer from './components/SlideViewer';
import RecentWork from './components/RecentWork';
import ContactForm from './components/ContactForm';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import AlertBanner from './components/AlertBanner';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <AlertBanner />
      
      {/* Latest News Banner */}
      <section className="bg-gradient-to-r from-teal-600 to-teal-700 py-4 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-newspaper-line text-2xl text-white"></i>
              </div>
              <div>
                <p className="text-white font-bold text-lg">
                  Latest News: ACI Officially Launches as California Think Tank
                </p>
                <p className="text-teal-100 text-sm">
                  Led by Luevano v. Campbell lead plaintiff Angel Luevano
                </p>
              </div>
            </div>
            <a 
              href="/newsroom"
              className="px-6 py-3 bg-white text-teal-700 rounded-lg hover:bg-teal-50 transition-colors font-semibold whitespace-nowrap cursor-pointer shadow-lg flex items-center gap-2"
            >
              Read Press Release
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      <Hero />
      <ProblemSection />
      <SolutionSection />
      <VideoSection />
      <SlideViewer />
      <RecentWork />
      <FAQSection />
      <ContactForm />
      <Footer />
    </div>
  );
}
